import { media, styled } from '@styles';
import { css, keyframes } from 'styled-components';

const pulse = keyframes`
  0% {
    box-shadow: 0 0 0 0 rgba(195, 76, 62, 1);
  }
  50% {
    box-shadow: 0 0 0 30px rgba(195, 76, 62, 0.5);
  }
`;

const pulse2 = keyframes`
  0% {
    box-shadow: 0 0 0 0 rgba(195, 76, 62, 1);
  }
  50% {
    box-shadow: 0 0 0 15px rgba(195, 76, 62, 0.5);
  }
`;

export const Wrapper = styled.div`
  position: relative;
  margin: 0 auto;
  width: 100%;
`;

export const Image = styled.img`
  margin: 0 auto;
  width: 100%;
`;

export const MarkerWrapper = styled.div`
  position: absolute;
`;

export const Marker = styled.div`
  position: absolute;

  width: 30px;
  height: 30px;
  background-color: transparent;
  border: 6px solid #a52e20;
  border-radius: 50%;

  box-sizing: border-box;
  cursor: pointer;

  transform: translate(-50%, -50%);

  animation: ${pulse} 3s cubic-bezier(0.19, 1, 0.22, 1) infinite both;

  ${media.smallScreen`
    width: 20px;
    height: 20px;
    border: 4px solid #a52e20;
    animation: ${pulse2} 3s cubic-bezier(0.19, 1, 0.22, 1) infinite both;
  `}
`;

export const Overlay = styled.div`
  ${({ theme }) => css`
    border: ${theme.popover.borderWidth} solid ${theme.popover.borderColor};
    border-radius: ${theme.popover.borderRadius};
    background: ${theme.popover.backgroundColor};
    box-shadow: ${theme.popover.shadow};
    color: ${theme.colors.white};

    .primitive-overlay {
      font-family: ${theme.typography.baseFontFamily};
      font-size: ${theme.typography.smallFontSize};
      line-height: ${theme.typography.baseLineHeight};
      padding: ${theme.popover.padding};
    }
  `}
  position: absolute;
  min-width: 220px;
  max-width: 350px;
  width: 30%;
  margin-top: -3%;

  transform: translate(-50%, -100%);

  z-index: 100;
`;

export const Arrow = styled.span`
  ${({ theme }) => css`
    position: absolute;
    width: 0;
    height: 0;
    bottom: calc(-${theme.popover.arrowSize} - 2px);
    left: calc(50% - ${theme.popover.arrowSize});
    transform: rotate(180deg);
    border-left: ${theme.popover.arrowSize} solid transparent;
    border-right: ${theme.popover.arrowSize} solid transparent;
    border-bottom: ${theme.popover.arrowSize} solid ${theme.popover.borderColor};

    &::after {
      position: absolute;
      content: ' ';
      width: 0;
      height: 0;
      top: 3px;
      left: calc(50% - ${theme.popover.arrowSize});
      border-left: ${theme.popover.arrowSize} solid transparent;
      border-right: ${theme.popover.arrowSize} solid transparent;
      border-bottom: ${theme.popover.arrowSize} solid
        ${theme.popover.backgroundColor};
      clip-path: inset(0 0 2px);
    }
  `}
`;

export const Content = styled.div`
  ${({ theme }) => css`
    display: flex;
    justify-content: center;
    align-items: center;
    font-family: ${theme.typography.baseFontFamily};
    font-size: ${theme.typography.smallFontSize};
    line-height: ${theme.typography.baseLineHeight};
    padding: ${theme.popover.padding};
  `}
`;

export const Text = styled.p`
  padding: ${({ theme: { spacing } }) =>
    `1rem ${spacing.gutter} 1.8rem ${spacing.gutter}`};
`;
